// Public keys and issuers the app trusts for entitlement tokens (decisions.md PWA-12). Production keys are added by
// `node scripts/gen-entitlement-keys.mjs --kid <id>`; the dev key (trusted-keys.dev.json) is trusted only in dev
// builds and in local end-to-end builds made with VITE_TRUST_DEV_KEYS=true (never set for a deployed build).

import production from './trusted-keys.json';
import development from './trusted-keys.dev.json';

const trustsDevKeys = import.meta.env.DEV || import.meta.env.VITE_TRUST_DEV_KEYS === 'true';

export const trustedKeys: Readonly<Record<string, JsonWebKey>> = trustsDevKeys
  ? { ...(production as Record<string, JsonWebKey>), ...(development as Record<string, JsonWebKey>) }
  : (production as Record<string, JsonWebKey>);

/** Token issuers: the production origin, plus the page's own origin (staging and local development). */
export function trustedIssuers(): string[] {
  const issuers = ['https://app.trailbivvy.com'];
  if (typeof location !== 'undefined' && !issuers.includes(location.origin)) issuers.push(location.origin);
  return issuers;
}
